import { render, staticRenderFns } from "./MainSettingsPanel.vue?vue&type=template&id=19e9e020"
import script from "./MainSettingsPanel.vue?vue&type=script&lang=js"
export * from "./MainSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./MainSettingsPanel.vue?vue&type=style&index=0&id=19e9e020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports